import styled from "styled-components";
import { Cores } from "../../styles/GlobalStyles";

// Estilo da seção principal
export const StoreCss = styled.section`
  width: 100%;
  padding: 80px 0;
  background-color: ${Cores.primary};
  color: ${Cores.textDark};
`;

// Estilo do título da seção
export const Title = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h2 {
    font-size: 2.5rem;
    color: ${Cores.textDark};
    margin-bottom: 12px;
  }

  p {
    font-size: 1.25rem;
    color: #666;
  }
`;

// Grid de itens
export const StoreGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

// Estilo de cada item do grid
export const StoreItem = styled.div`
  background: ${Cores.secondary};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.15);
  }

  img,
  video {
    width: 100%;
    height: 340px;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img,
  &:hover video {
    transform: scale(1.05);
  }

  h3 {
    font-size: 1.3rem;
    margin: 20px;
    color: ${Cores.textDark};
    text-align: center;
  }

  p {
    font-size: 1rem;
    margin: 0 20px 20px;
    color: #666;
    line-height: 1.6;
    flex-grow: 1;
    text-align: center;
  }

  @media (max-width: 1024px) {
    img,
    video {
      height: 300px;
    }
  }

  @media (max-width: 768px) {
    img,
    video {
      height: 260px;
    }

    h3 {
      font-size: 1.2rem;
      margin: 16px;
    }

    p {
      font-size: 0.95rem;
      margin: 0 16px 16px;
    }
  }
`;

export const WhyChooseUs = styled.div`
  margin-top: 100px;
  text-align: center;

  h2 {
    font-size: 2rem;
    color: ${Cores.textDark};
    margin-bottom: 40px;
  }
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const BenefitItem = styled.div`
  text-align: center;

  h3 {
    font-size: 1.25rem;
    color: ${Cores.textDark};
    margin-bottom: 8px;
    font-weight: 600;
  }

  p {
    font-size: 1rem;
    color: #666;
    line-height: 1.5;
  }
`;
